
import Logger from '@/logger'
import ServiceBasket from '@/models/service-basket'
import ServiceBasketItem from '@/models/service-basket-item'

const MUTATIONS = {
    setBasket: 'set-basket',
    addItemToBasket: 'add-item-to-basket',
    removeItemFromBasket: 'remove-item-from-basket',
    resetState: 'reset-state',
}

const LOGGING_CATEGORY = 'Service Basket (Vuex)'

export { MUTATIONS }

export default {
    /**
     * Override an existing basket with the new one.
     * @param {Object} state
     * @param {ServiceBasket} basket
     */
    [MUTATIONS.setBasket](state, basket) {
        state.basket = ServiceBasket.ensure(basket)

        Logger.logObject({ ...state }, 'Store new basket', LOGGING_CATEGORY)
    },

    /**
     * Reset the basket state.
     * @param {Object} state
     */
    [MUTATIONS.resetState](state) {
        state.basket = new ServiceBasket()

        Logger.logObject({ ...state }, 'Reset basket', LOGGING_CATEGORY)
    },

    /**
     * Add an item to the basket.
     * @param {Object} state
     * @param {ServiceBasketItem} item
     */
    [MUTATIONS.addItemToBasket](state, item) {
        state.basket.items = [
            ...state.basket.items,
            ServiceBasketItem.ensure(item),
        ]

        Logger.logObject({ ...state }, 'Add item to basket', LOGGING_CATEGORY)
    },

    /**
     * Remove a item from the basket.
     * @param {Object} state
     * @param {ServiceBasketItem} item
     */
    [MUTATIONS.removeItemFromBasket](state, item) {
        state.basket.items = state.basket.items.filter(({ serviceTypeId }) => serviceTypeId !== item.serviceTypeId)

        Logger.logObject({ ...state }, 'Remove item from basket', LOGGING_CATEGORY)
    },
}
